import { Component, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeProcom } from '@app/models/entity.model';
import { ProductLayoutComponent } from '@app/components/product/product-layout/product-layout.component';

@Component({
  selector: 'mobi-node-procom',
  templateUrl: './node-procom.component.html',
  styleUrls: ['./node-procom.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, ProductLayoutComponent],
})
export class NodeProcomComponent {
  readonly entity = input.required<NodeProcom>();
}
